import { render, staticRenderFns } from "./CabecalhoRepeticao.vue?vue&type=template&id=107d82c0"
import script from "./CabecalhoRepeticao.vue?vue&type=script&lang=js"
export * from "./CabecalhoRepeticao.vue?vue&type=script&lang=js"
import style0 from "./CabecalhoRepeticao.vue?vue&type=style&index=0&id=107d82c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports